import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  key: string;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }

  setKey(k) {
    this.key = k;
  }

  get(url, options = {}) {
    options = this.setOptions(options);
    return this.http.get(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  rawGet(url, options: any = {}) {
    options = this.setOptions(options);
    options.responseType = 'blob'
    return this.http.get(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  post(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.post(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  uploadFiles(url, fileName, files, data=null, options = {}){
    options = this.setOptions(options,false);
    let formData = new FormData();
    files.forEach((file,i) => {
      formData.append(fileName[i], file, file.name);
    });
    if(data){
      formData.append('data', JSON.stringify(data));
    }
    return this.http.post(url, formData, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  delete(url, options = {}) {
    options = this.setOptions(options);
    return this.http.delete(url, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  put(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.put(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  patch(url, body, options = {}) {
    options = this.setOptions(options);
    return this.http.patch(url, body, options)
      .toPromise()
      .then(r => this.handleResponse(r))
      .catch(r => this.handleError(r));
  }

  private handleError(res) {
    if (res.status === 401) {
      // Apenas lança o erro 401 - deixa o código chamador decidir o que fazer
      // O redirecionamento para login deve ser feito pelo SessionService
      throw 401;
    } else if (res.status >= 300)
      throw res.status;
    throw res;
  }
  private handleResponse(res) {
    if (res.status === 401) {
      // Apenas lança o erro 401 - deixa o código chamador decidir o que fazer
      throw 401;
    }
    if (res.status >= 300)
      throw res.status;
    return res.body;
  }

  private setOptions(options,contentType:any='application/json') {
    let header: HttpHeaders = new HttpHeaders();
    if(contentType)
      header = header.append('Content-Type', contentType);
    if (this.key)
      header = header.append("Authorization", "Bearer " + this.key);
    options = Object.assign({ headers: header }, options, { observe: 'response' });
    return options;
  }
}
